import axios from "axios";

const useGet = async (url, config) => {
  try {
    const { data } = await axios.get(url, { params: config });
    return [data, null];
  }
  catch (error) {
    return [null, error];
  }
};

export default useGet;
